import type { SvgIconProps } from '../../types/props.ts'

export const QuickFrameIcon = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <g filter="url(#filter0_d_18609_107058)">
        <path
          d="M7.92578 11.9925C7.92578 8.68294 10.8229 6 14.3966 6H48.9076C52.4814 6 55.3785 8.68294 55.3785 11.9925V48.0075C55.3785 51.3171 52.4814 54 48.9076 54H14.3966C10.8229 54 7.92578 51.3171 7.92578 48.0075V11.9925Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_d_18609_107058)">
        <rect
          x="8.26519"
          y="6.26519"
          width="47.4696"
          height="47.4696"
          rx="5.73481"
          stroke="url(#paint0_radial_18609_107058)"
          strokeOpacity="0.4"
          strokeWidth="0.530387"
          shapeRendering="crispEdges"
        />
        <rect
          x="8.26519"
          y="6.26519"
          width="47.4696"
          height="47.4696"
          rx="5.73481"
          stroke="white"
          strokeOpacity="0.05"
          strokeWidth="0.530387"
          shapeRendering="crispEdges"
        />
        <g filter="url(#filter2_d_18609_107058)">
          <path
            d="M34.4167 29.0258C34.4167 22.9622 30.2259 18.3252 24.1038 18.3252C17.8897 18.3252 13.7285 22.9622 13.7285 29.0258C13.7285 35.0894 17.8897 39.7271 24.1038 39.7271C25.4228 39.7352 26.7324 39.5034 27.9685 39.0431L29.8709 41.8081L32.2787 40.1428L30.5245 37.6165C32.9605 35.6845 34.4167 32.5934 34.4167 29.0258ZM28.8586 35.2383L26.659 32.088L24.252 33.7228L26.3026 36.6953C25.5879 36.9015 24.8468 37.0013 24.103 36.9917C19.5253 36.9917 16.7907 33.4545 16.7907 29.025C16.7907 24.5955 19.5246 21.0598 24.1038 21.0598C28.6244 21.0598 31.3568 24.597 31.3568 29.0258C31.3553 31.5529 30.4638 33.7821 28.8586 35.2383Z"
            fill="url(#paint1_linear_18609_107058)"
            fillOpacity="0.9"
          />
          <path
            d="M37.0742 21.6517H40.1357V21.6458H50.2715V18.9111H37.0742V21.6517Z"
            fill="#15D17C"
          />
          <path
            d="M37.0742 21.6517H40.1357V21.6458H50.2715V18.9111H37.0742V21.6517Z"
            fill="#009BE7"
          />
          <path
            d="M37.0742 39.7181H40.1357V31.0985H49.0836V28.4395H37.0742V39.7181Z"
            fill="url(#paint2_linear_18609_107058)"
            fillOpacity="0.9"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_18609_107058"
          x="5.92578"
          y="4"
          width="55.4531"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18609_107058"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18609_107058"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_18609_107058"
          x="0"
          y="0"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18609_107058"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18609_107058"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_18609_107058"
          x="9.72852"
          y="16.3252"
          width="44.543"
          height="31.4824"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18609_107058"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18609_107058"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_18609_107058"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35.9594 54) rotate(-112.946) scale(38.279 20.8963)"
        >
          <stop stopColor="white" stopOpacity="0.8" />
          <stop offset="0.275" stopColor="white" stopOpacity="0.3" />
          <stop offset="1" stopColor="white" stopOpacity="0.05" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_18609_107058"
          x1="24.0726"
          y1="18.3252"
          x2="24.0726"
          y2="41.8081"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18609_107058"
          x1="43.0789"
          y1="28.4395"
          x2="43.0789"
          y2="39.7181"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  )
}
